var ValueJS = ValueJS || {};

ValueJS.TextRotator = function() {

    var _defaults = {
        animation: 'dissolve',      // dissolve (default), fade, flip, flipUp, flipCube, flipCubeUp and spin.
        separator: '|',
        speed: 2000                 // delay in milliseconds
    }

    var _init = function() {
        $('.rotate').each(function() {
            let el = $(this);
            el.textrotator({
                animation:      el.data('rotate-fx') || _defaults.animation,
                separator:      el.data('rotate-separator') || _defaults.separator,
                speed:          el.data('rotate-speed') || _defaults.speed
            });
        })
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
    };

}();

$(function() {
    ValueJS.TextRotator.init();
});
